import MediaIcon from './MediaIcon'
const MediaIcons = ({ imageClicked, mediaIcons, setPosterImage }) => {
    //const { mediaIcons } = useSelector(state => state.song)
    console.log('MediaIcons loaded', mediaIcons)

    const displayIcons = () => {
        //console.log('MediaIcons displayMIcons', mediaIcons)
        return mediaIcons.map((f, ix) =>
            <MediaIcon key={ix} icon={f} ix={ix} imageClicked={() => imageClicked(ix)}
                setPosterImage={setPosterImage}
            />)
    }

    if (mediaIcons.length) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                {displayIcons()}
            </div>
        )
    } else { return null }
}

export default MediaIcons